import { ResultDetailContainer, ResultSet } from '../interfaces/result.interfaces'
import { SelectInputOptions } from '../../shared/select-input/select-input.component'

/**
 * The result component is very old code and these utility methods
 * were abstracted in order to test some complicated logic. However,
 * the component and these methods could further be improved and
 * are not considered best practices.
 * @deprecated These methods support old standalone results and are not best practices
 */
export function mapResultSelectOptions(resultObj: ResultDetailContainer): SelectInputOptions {
  const selectObj: SelectInputOptions = {}

  resultObj.resultSet.map((resultParent: ResultSet) => {
    if (resultParent.filter !== null) {
      selectObj[resultParent.id.toString()] = resultParent.filter
    }
  })

  return selectObj
}

/**
 * @deprecated These methods support old standalone results and are not best practices
 */
export function mapToResultContent(
  resultObj: ResultDetailContainer
): ReadonlyArray<ResultSet & { showContent?: boolean }> {
  return resultObj.resultSet
    .filter((resultSet: ResultSet) => {
      return Number(resultObj.sort)
        ? resultSet.id.toString() === (resultObj.sort && resultObj.sort.toString())
        : resultObj.resultSet
    })
    .map((result: ResultSet) => {
      return {
        ...result,
        showContent: !resultObj.should_show_read_more
      }
    })
}
